import sha256 from 'jssha/dist/sha256'
import { URL_DOMAIN, TEXT_PREFIX } from '../../config.json'

/* 获取参与签名的参数（过滤掉null/undefined值）
 * @param {Object} data - 请求对象
 * @param {Set<string>} [paramNames] - 需要参与签名的参数名集合（默认使用标准集合）
 * @returns {Object} 过滤后的参数对象
 */
const getSignParams = (data) => {
  const paramNames = new Set(['sysnum', 'timestamp', 'uid', 'source', 'cid'])
  const params = {}
  for (const name of paramNames) {
    if (data[name] != null) {
      // 过滤null/undefined
      params[name] = data[name]
    }
  }
  return params
}

const processQueryParams = (queryString) => {
  if (!queryString) return "";
  const str = decodeURIComponent(queryString);
  const pairs = str.split("&");
  const params = {};
  pairs.forEach((pair) => {
    const [key, ...valueParts] = pair.split("=");
    params[key] = valueParts.join("=");
  });

  const sortedKeys = Object.keys(params).sort();
  const result = sortedKeys.map((key) => params[key]).join("");
  return result;
};

/**
 * 生成签名（异步方法）
 * @param {string} path - 请求路径
 * @param {Object} headers - 参数对象
 * @returns {Promise<string>} 16进制小写签名
 */
export const sign = (path, data) => {
  // 签名密钥
  const secret = 'sobot*&^%$#@!'

  const requestURI = path.split('?')[0]
  const queryParams = processQueryParams(path.split('?')[1])

  // 4. 拼接签名内容（完全匹配Java逻辑）
  const signatureContent = secret + requestURI + queryParams + secret

  // 生成签名
  const shaObj = new sha256('SHA-256', 'TEXT', {
    hmacKey: { value: secret, format: 'TEXT' }
  })
  shaObj.update(signatureContent)
  const hexSign = shaObj.getHash('HEX')

  return hexSign
}

function isSignedApi(url) {
  const signedApis = ['/chat-web/data/invokeOtherByUser.action']
  const { pathname } = new URL(url, window.location.origin)
  
  return signedApis.includes(pathname)

}

export default (props) => {
  const headers = {
    sysnum: props?.sysnum ?? '',
    timestamp: Date?.now(),
    uid: props?.uid ?? '',
    cid: props?.cid ?? ''
  }
  for (const key in headers) {
    if (!headers[key]) {
      delete headers[key]
    }
  }
  const path = props?.url.replace(URL_DOMAIN + TEXT_PREFIX, '')
  if (headers['sysnum'] && isSignedApi(path)) {
    headers['visitorSign'] = sign(path, headers)
  }
  return headers
}
